import { Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';

@Component({
  selector: 'app-copy-item-button',
  standalone: false,
  templateUrl: './copy-item-button.component.html',
  styleUrls: ['./copy-item-button.component.css'],
})
export class CopyItemButtonComponent extends BaseComponent {
  constructor(private toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
  }

  public onCopyClick(event: Event): void {
    if (event) {
      event.stopPropagation();
    }
    // Trigger copy event through toolbar event manager
    this.toolbarEventManagerHelper.CopyItemTrigger = true;
  }
}
